module.exports = __webpack_public_path__ + "media/images/front/top/main_visual-dfce466b3b31f4c192c892f0171c48e5.png";